import { getReviewBankTransactions, useBankConnections } from '@easy-expense/data-firestore-client';
import { getTranslation } from '@easy-expense/intl-client';
import { Icon } from '@easy-expense/ui-shared-components';
import { theme } from '@easy-expense/ui-theme';
import { Layout, OpenSans, Spacer } from '@easy-expense/ui-web-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { MeteredPaywallActions, useHandleMeteredAction } from '../hooks/useHandleMeteredAction';

export const BankTransactionHeader: React.FC = () => {
  const navigate = useNavigate();
  const numberOfBankTransaction = getReviewBankTransactions().length;
  const bankConnections = useBankConnections();
  const handleMeteredReview = useHandleMeteredAction(MeteredPaywallActions.LINK_MULTIPLE_ACCOUNTS);
  const hasMultipleBankConnections =
    bankConnections.filter((connection) => connection.status === 'CONNECTED').length > 1;

  const openReview = () => navigate('/review/bank', { state: { transactionType: 'bank' } });

  if (!(numberOfBankTransaction > 0)) {
    return null;
  }

  return (
    <Layout.Row>
      <Layout.PressableRow
        px={16}
        py
        border={[1, 'solid', 'brandPrimary']}
        radius={8}
        align
        bg="brandPrimaryXLight"
        onClick={() => {
          if (hasMultipleBankConnections) {
            handleMeteredReview(openReview);
          } else {
            openReview();
          }
        }}
      >
        <Icon name="cash-outline" size={24} color={theme.colors.brandPrimary} />
        <Spacer.Horizontal size={16} />
        <Layout.Column>
          <OpenSans.Primary weight="bold-700" size="s-16">
            {numberOfBankTransaction + ' ' + getTranslation('Bank Transactions')}
          </OpenSans.Primary>
        </Layout.Column>
      </Layout.PressableRow>
    </Layout.Row>
  );
};
